<template>
  <div ref="el" class="aspect-video">
    <div v-if="shouldRender" class="size-full">
      <MediaRemoteVideoYouTube
        v-if="youtubeId"
        :id="youtubeId"
        class="!h-auto !w-full"
      />
      <MediaRemoteVideoVimeo v-else-if="vimeoId" :id="vimeoId" class="w-full" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getYouTubeID } from '~/helpers'

const el = ref<HTMLDivElement>()
const shouldRender = useRenderWhenVisible(el)

const props = defineProps<{
  url?: string
}>()

const vimeoId = computed<number | null>(() => {
  const url = props.url || ''
  const matches = url.match(/\/(\d+)/) || []
  const id = matches[1]

  if (!id) {
    return null
  }

  const v = parseInt(id)

  if (Number.isNaN(v)) {
    return null
  }

  return v
})

const youtubeId = computed(() => (props.url ? getYouTubeID(props.url) : null))
</script>
